export default __webpack_public_path__ + "static/media/ss-passport.dc3f5d16.jpg";